module.exports = __webpack_public_path__ + "static/media/Modern V VR.937f112.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Modern V VR.mp3
// module id = 15ZP
// module chunks = 12